import type { NoteBlockModel } from '@blocksuite/affine-model';
import { assertValidBlockXYWH, Bound } from '@blocksuite/global/gfx';

export function getPersistedNoteBound(model: NoteBlockModel) {
  const persistedXYWH = model.yBlock.get('prop:xywh');
  assertValidBlockXYWH(persistedXYWH, {
    blockId: model.id,
    flavour: model.flavour,
    key: 'xywh',
  });

  return Bound.deserialize(persistedXYWH);
}
